import { Typography, WithStyles, withStyles } from "@material-ui/core";
import { styles } from "../admin/EmptyOrderView.styles"; 
import React from "react";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";

export interface IMultipleSubscriptionsSuccessViewProps extends WithStyles<typeof styles> {
}

const MultipleSubscriptionsSuccessViewPure: React.FunctionComponent<IMultipleSubscriptionsSuccessViewProps> = ({ classes }) => {
    return (
        <CenteredContainer>
            <div className={classes.title}>
                <Typography variant="h2">Add multiple subscriptions</Typography>
            </div>
            <Typography variant="h3">Success!</Typography>
            <Typography variant="body1">Multiple subscriptions were created for the selected user.</Typography>
        </CenteredContainer>
    );
};

export const MultipleSubscriptionsSuccessView = withStyles(styles)(MultipleSubscriptionsSuccessViewPure);